import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import apiClient from '../../api/apiClient';
import { Box, CircularProgress, Typography } from '@mui/material';
import { getMyCountries } from '../../api/countryApi';
import { useCountry } from '../../contexts/CountryContext';
import { getHomeRouteByRole } from '../../utils/roleRedirect';

const OAuth2Callback = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { setCountries, selectCountry } = useCountry();

    useEffect(() => {
        const processToken = async () => {
            const queryParams = new URLSearchParams(location.search);
            const token = queryParams.get('token');

            if (token) {
                // 1. Guardar el token (asegúrate de que apiClient lo use en sus headers)
                localStorage.setItem('token', token);
                localStorage.setItem('loginProvider', 'azure');

                try {

                    const response = await apiClient.get('/User/me', {
                        headers: { Authorization: `Bearer ${token}` }
                    });
                    
                    const user = response.data;
                    localStorage.setItem('user', JSON.stringify(user));

                    const userRole = user?.rols?.description || '';

                    // Multi-país: resolver los países del usuario (igual que el login local).
                    const countries = await getMyCountries();
                    setCountries(countries);

                    if (countries.length > 1) {
                        // Varios países: el usuario elige con cuál trabajar.
                        selectCountry(null);
                        navigate('/seleccionar-pais');
                    } else {
                        // Un país (o ninguno): entra directo según el rol.
                        selectCountry(countries.length === 1 ? countries[0] : null);
                        navigate(getHomeRouteByRole(userRole));
                    }
                } catch (error) {
                    console.error("Error obteniendo el perfil del usuario", error);
                    navigate('/?error=user_not_found');
                }
            } else {
                navigate('/');
            }
        };

        processToken();
    }, [location, navigate]);

    return (
        <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" height="100vh">
            <CircularProgress size={60} />
            <Typography variant="h6" sx={{ mt: 2, color: '#004F86' }}>
                Completando inicio de sesión...
            </Typography>
        </Box>
    );
};

export default OAuth2Callback;